import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    text: {
      color: theme.palette.primary.main,
      fontWeight: "semi-bold",
    },
    form: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
    },
    margin: {
      marginTop: "1.4rem",
    },
    subForm: {
      display: "flex",
      justifyContent: "space-between",
    },
    switch: {
      color: "#0000008A",
    },
    footer: {
      marginTop: "1.2rem",
    },
    footerItem: {
      marginTop: "2rem",
    },
    label: {
      fontSize: "0.8rem",
      "& label": { fontSize: "0.8rem" },
    },
    selectEmpty: {
      // muioutlinedinputInput: {
      
      // }
    },
    select: {
      background: '#F5F6F9',
      paddingLeft: "24px",
      paddingTop: 14,
      paddingBottom: 15,
      
    },
    formControl: {
      margin: theme.spacing,
    },
  })
);

export default useStyles;
